/** Default State object.
 *
 *  Useful to ...spread into your state so we don't have to have so much boilerplate around.
 *
 */
export const DefaultState = {
  isFetching: false,
  didInvalidate: false,
  lastUpdated: null,
  error: null,
  details: null
}
